/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.CustomsDeclarationItemResponseDto>
>;
export function request(
  params: API.tms.customsDeclarationItem.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationItem/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
